import { useCartStateSelector } from './useCartStateSelector';

export function useIsArticleInCart(articleNumber: string, isExternal: boolean) {
  const isArticleInCart = useCartStateSelector<boolean>(state => {
    if (isExternal) {
      return (
        state?.context?.currentOrder?.externalGroupedPositions?.some(group =>
          group.externalPositions.some(position => position.articleNumber === articleNumber)
        ) ?? false
      );
    } else {
      return (
        state?.context?.currentOrder?.normalPositions
          ?.concat(state?.context?.currentOrder?.profitPlusPositions)
          .some(group => group.positions.some(position => position.articleBaseNo === articleNumber)) ?? false
      );
    }
  });
  return isArticleInCart;
}
